import {
  LOAD_DASHBOARDS,
  LOAD_DASHBOARDS_SUCCESS,
  LOAD_DASHBOARDS_ERROR,
} from "../Types/dashboards.constants";

const INITIAL_STATE = {
  loading: false,
  dashboards: [],
  error: null,
};

export const dashboardsListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAD_DASHBOARDS:
      return { ...state, loading: true, dashboards: [] };
    case LOAD_DASHBOARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboards: action.payload,
      };
    case LOAD_DASHBOARDS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
